import { useState, useCallback } from 'react';
import { fetchReportChartData } from '../utils/reportChartData';

const useReportChartData = () => {
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);

  const loadReportChartData = useCallback(
    async ({
      reportId,
      chartId,
      limit = 10000,
      filters = {},
      existingChartConfig = null,
      runningUserId = null,
      dashboardId = null,
      viewAsUserId = null,
      baseCurrencyCode = null,
      exchangeRateLookup = null,
      multiCurrencyEnabled = true,
    }) => {
      setLoading(true);
      setError(null);
      try {
        const result = await fetchReportChartData({
          reportId,
          chartId,
          limit,
          filters,
          existingChartConfig,
          runningUserId,
          dashboardId,
          viewAsUserId,
          baseCurrencyCode,
          exchangeRateLookup,
          multiCurrencyEnabled,
        });
        return result;
      } catch (err) {
        setError(err);
        throw err;
      } finally {
        setLoading(false);
      }
    },
    []
  );

  return {
    loadReportChartData,
    loading,
    error
  };
};

export default useReportChartData;
